const paths = {
    adList: '/advertisements',
    adDetails: '/advertisements/details',
    adAvailability: '/advertisements/availability',
    updateAd: '/advertisements/update'
}

export default paths